import { Checkbox, makeStyles } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { IndeterminateCheckBoxOutlined } from '@material-ui/icons';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import clsx from 'clsx';
import { ReactElement } from 'react';

import { getIcon, IconType } from '../modules/data';

type AutocompleteItemProps = {
  checked?: boolean;
  iconType?: IconType;
  hideIcon?: boolean;
  value: string;
  alt?: string;
  IconComponent?: ({ value }: { value: string }) => ReactElement;
  label: string;
  hideCheckbox?: boolean;
  indeterminate?: boolean;
  boldLabel?: boolean;
  historicOption?: boolean;
  exclusiveMode?: boolean;
};

const useStyles = makeStyles((theme) => ({
  checkbox: { marginRight: theme.spacing(1), padding: 0 },
  iconImage: { display: 'inline-block', width: 20, height: 'auto', marginRight: theme.spacing(1) },
  bold: { fontWeight: 'bold' },
  checkboxText: { textWrapStyle: 'balanced' },
  historicOption: {
    color: grey[400],
  },
}));

const AutocompleteItem = ({
  checked = false,
  iconType,
  hideIcon = false,
  value,
  alt,
  IconComponent,
  label,
  hideCheckbox,
  indeterminate = false,
  boldLabel = false,
  historicOption = false,
  exclusiveMode = false,
}: AutocompleteItemProps) => {
  const classes = useStyles();
  return (
    <>
      {!hideCheckbox && (
        <Checkbox
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={
            exclusiveMode ? <IndeterminateCheckBoxIcon fontSize="small" /> : <CheckBoxIcon fontSize="small" />
          }
          className={classes.checkbox}
          checked={checked}
          indeterminate={indeterminate}
          indeterminateIcon={<IndeterminateCheckBoxOutlined fontSize="small" />}
        />
      )}
      {iconType && !hideIcon && <img src={getIcon(iconType, value)} alt={alt} className={classes.iconImage} />}
      {iconType && hideIcon && <span className={classes.iconImage} />}
      {IconComponent && <IconComponent value={value} />}
      <span
        className={clsx(
          boldLabel && classes.bold,
          !hideCheckbox && classes.checkboxText,
          historicOption && classes.historicOption,
        )}
      >{` ${label}`}</span>
    </>
  );
};

export default AutocompleteItem;
